import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import useMedicineStore from '../../../../zustandstores/medicinecart.store';
import MedQtyBtn from '../../../../components/med-qty-btn/med-qty-btn.component';

const MedAddToCartBtn = ({medicine}) => {
    const addToCart = useMedicineStore(state => state.addToCart);
    const cartTracker = useMedicineStore(state => state.cartTracker);

    const handleAddToCart = () => {
        // NOTE: This item should be of MedCartItemType as present in app.types.js file.
        const cartItem = {
            id: medicine.id,
            name: medicine.medicine_name,
            description: medicine.product_details,
            price: +medicine.price,
            basePrice: +medicine.price,
            qty: 1,
        };

        addToCart(cartItem);
        // updateCartOrderInfo({orderType: 'Medicine'});

        document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.TOGGLE_NOTIFY, {
            detail: {
                open: true,
                message: `${medicine.medicine_name} - Added to cart successfully.`,
            },
        }));
    };
    const btnContent = () => {
        if (cartTracker.has(medicine.id)) {
            return <MedQtyBtn medicineID={medicine.id} />;
        }

        return (
            <Button size='small' variant='contained' className='btn-square' onClick={handleAddToCart}>
                Add to Cart
            </Button>
        );
    };
    return btnContent();
};

export default MedAddToCartBtn;
MedAddToCartBtn.propTypes = {
    medicine: PropTypes.object.isRequired
};